"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterListItemText = exports.StyledFilterChildListItem = exports.StyledFilterUl = exports.StyledFilterListSubheader = exports.StyledFilterContent = exports.StyledFilterContainer = exports.StyledFilterButton = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFilterButton = (0, styled_components_1.default)(material_1.IconButton) `
  white-space: nowrap;
  padding: 0;
  margin: 0;
  min-width: 2rem;

  &:hover,
  &:focus,
  &:active,
  &:focus-visible {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  svg path {
    fill: none;
  }

  &:active {
    svg path {
      fill: ${ui_components_1.baseColors.teal300};
    }
  }

  &.menu--open {
    background-color: transparent !important;

    svg path {
      fill: ${ui_components_1.baseColors.teal300};
    }
  }

  svg {
    scale: 0.8;
  }
`;
exports.StyledFilterContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1)};
  max-width: 300px;
  min-width: 280px;

  .actions {
    display: flex;
    justify-content: space-between;
  }

  .footer {
    display: flex;
    justify-content: space-between;
  }
`;
exports.StyledFilterContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: ${({ theme }) => theme.spacing(1.5)};
  max-height: 300px;
  min-width: 280px;

  .empty-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    color: ${ui_components_1.baseColors.primaryGray200};
    padding: ${({ theme }) => theme.spacing(4, 0)};
  }
`;
exports.StyledFilterListSubheader = (0, styled_components_1.default)(material_1.ListSubheader) `
  padding: 0;
  z-index: 3;

  .subheader-content {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
exports.StyledFilterUl = styled_components_1.default.ul `
  padding: ${({ theme }) => theme.spacing(1.2)} 0;
`;
exports.StyledFilterChildListItem = (0, styled_components_1.default)(material_1.ListItem) `
  padding-left: ${({ theme }) => theme.spacing(10)};
`;
exports.StyledFilterListItemText = (0, styled_components_1.default)(material_1.ListItemText) `
  .MuiTypography-root {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
`;
